module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--8--create-c494b287.jpg";